class HallItems extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.buttons = [...this.querySelectorAll('[data-hall-tab]')];
    this.panels = [...this.querySelectorAll('[data-hall-panel]')];
    if (this.buttons.length <= 1) return;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.hallTab);
        if (!index) return;
        this.activate(index);
      });
    });
  }

  activate(index) {
    this.buttons.forEach((button) => {
      const on = Number(button.dataset.hallTab) === index;
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.hidden = Number(panel.dataset.hallPanel) !== index;
    });
  }
}

if (!customElements.get('hall-items')) {
  customElements.define('hall-items', HallItems);
}
